import React from 'react';
import { CheckIcon, AlertTriangleIcon, RefreshCwIcon } from 'lucide-react';
import { onboardings, type Checkpoint } from '../lib/data';
function CheckpointMarker({
  point
}: {
  point: Checkpoint;
}) {
  const styles = {
    done: 'border-ink bg-ink text-white',
    due: 'border-attention bg-attention-soft text-attention-text',
    upcoming: 'border-line bg-canvas text-muted'
  }[point.status];
  return <div className="flex items-center gap-1.5" data-id="element-189" data-mp="2cpoen5xoi671">
      <span className={`flex h-4 w-4 items-center justify-center rounded-full border ${styles}`} data-id="element-190" data-mp="2cnbvipg6ppse">
        {point.status === 'done' && <CheckIcon className="h-2.5 w-2.5" strokeWidth={3} data-id="element-191" data-mp="22qysh0yr1zkz" />}
        {point.status === 'due' && <span className="h-1.5 w-1.5 rounded-full bg-attention" data-id="element-192" data-mp="1xs5rg80ng11p" />}
      </span>
      <span className={`text-[12px] font-500 ${point.status === 'done' ? 'text-ink' : point.status === 'due' ? 'text-attention-text' : 'text-muted'}`} data-id="element-193" data-mp="1xu8f4lebxi39">
        {point.label}
      </span>
    </div>;
}
export function OnboardingTracking() {
  return <section className="mx-auto w-full max-w-6xl px-5 py-7 sm:px-8" data-id="element-194" data-mp="1isvph7flkg7v">
      <h2 className="font-serif text-2xl font-500 tracking-[-0.02em] text-ink" data-id="element-195" data-mp="1ipzrjj3r1rjf">Suivi d'intégration</h2>
      <p className="mt-1 text-[13px] text-muted" data-id="element-196" data-mp="13xfv11b3uiay">
        À J+90, la prédiction initiale est confrontée au résultat observé.
      </p>

      <div className="mt-3 divide-y divide-line border-t border-line" data-id="element-197" data-mp="v2htx6xszz8j">
        {onboardings.map(item => {
        const complete = item.checkpoints.every(p => p.status === 'done');
        return <div key={item.id} className={`flex flex-col gap-4 py-5 lg:flex-row lg:items-center lg:justify-between lg:gap-6 ${item.alert ? 'border-l-2 border-attention pl-4' : ''}`} data-id="element-198" data-mp="l5n216w1cx38">
              <div className="min-w-0 lg:w-64 lg:flex-none" data-id="element-199" data-mp="g5hcpxd8nmob">
                <h3 className="text-[15px] font-500 text-ink" data-id="element-200" data-mp="g4z6c7wv3s2o">{item.name}</h3>
                <p className="mt-0.5 text-[13px] text-muted" data-id="element-201" data-mp="2it7j68q6zerp">
                  {item.title} · {item.department}
                </p>
              </div>

              <div className="flex flex-wrap items-center gap-4 lg:gap-6" data-id="element-202" data-mp="292cnkdr232tl">
                {item.checkpoints.map(point => <CheckpointMarker key={point.label} point={point} data-id="element-203" data-mp="2441dq30rgsbd" />)}
              </div>

              <div className="lg:w-72 lg:flex-none lg:text-right" data-id="element-204" data-mp="31pz1aetzznu6">
                {item.alert ? <span className="inline-flex items-center gap-1.5 rounded-full border border-attention/60 bg-attention-soft px-3 py-1 text-[12px] font-500 text-attention-text" data-id="element-205" data-mp="2wsyws8csqt56">
                    <AlertTriangleIcon className="h-3.5 w-3.5" strokeWidth={2} data-id="element-206" data-mp="2nrsd5qeup27p" />
                    {item.alert}
                  </span> : complete ? <span className="inline-flex items-center gap-1.5 rounded-full bg-ink px-3 py-1 text-[12px] font-500 text-white" data-id="element-207" data-mp="1gbcjk2sq5z1x">
                    <RefreshCwIcon className="h-3.5 w-3.5" strokeWidth={2} data-id="element-208" data-mp="3o08hy9rilads" />
                    Résultat mesuré · apprentissage disponible
                  </span> : <span className="text-[12px] text-muted" data-id="element-209" data-mp="uzmdc70lhwv">Suivi en cours</span>}
              </div>
            </div>;
      })}
      </div>
    </section>;
}